import { Component, OnInit } from "@angular/core";
import { AuthenticationService } from "@app/core/startup";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import { CookieService } from "ngx-cookie-service";
import { SharedService } from "../..";
import { MessageService } from "../../services/message.service";

@Component({
  selector: "app-cookie-component",
  templateUrl: "./cookie-component.component.html",
  styleUrls: ["./cookie-component.component.scss"],
})
export class CookieComponentComponent implements OnInit {
  selected: boolean = false;
  checked: boolean;
  functional: boolean;
  tracking: boolean = false;
  performance: boolean = false;
  personalization: boolean = false;
  payload: object = {};
  payload1: object = {};
  cookieValue: string = "";
  showPopup: boolean = false;
  modalRef: any;
  isCustomizePopupOpened: boolean = false;

  constructor(
    private modalService: NgbModal,
    private cookieService: CookieService,
    private authService: AuthenticationService,
    private sharedService: SharedService,
    private messageService: MessageService,
    private translate: TranslateService
  ) {
  }
  ngOnInit(): void {
    setInterval(() => {
      if (this.cookieService.get("platform-cookies") || this.isCustomizePopupOpened) {
        this.showPopup = false;
      } else {
        this.showPopup = true;
      }
    }, 10000)
  }

  openModel(content) {
    this.isCustomizePopupOpened = true;
    this.modalRef = this.modalService.open(content, {
      centered: true,
      modalDialogClass: "cookie-modal",
    });

    this.showPopup = false;
  }

  closeModel() {
    this.tracking = false;
    this.performance = false;
    this.personalization = false;
    this.modalRef.close();
    this.showPopup = true;
    this.isCustomizePopupOpened = false;
  }

  toggle() {
    this.selected = this.checked;
  }

  submitCookie(modals) {
    console.log(
      "functional",
      this.functional,
      "tracking",
      this.tracking,
      "performance",
      this.performance,
      "personalization",
      this.personalization
    );
    this.payload1 = {
      functional: true,
      tracking: this.tracking,
      performance: this.performance,
      personalization: this.personalization,
    };
    let expireDate = new Date;
    expireDate.setDate(expireDate.getDate() + 730);
    this.cookieService.set("platform-cookies", JSON.stringify(this.payload1), expireDate);
    if (!this.authService.checkUser()) {
      this.showPopup = false;
      this.messageService.showSuccess(this.translate.instant("cookiePolicy.savedSuccessfully"))
      this.modalRef.close();
    } else {
      this.sharedService.getCookies().subscribe((res: any) => {
        if (
          this.cookieService.get("platform-cookies") &&
          !res.isUserAcceptedCookiePolicy
        ) {
          let cookie_data = JSON.parse(
            this.cookieService.get("platform-cookies")
          );
          this.payload = {
            contentPageId: res.contentPage.id,
            version: res.contentPage.version,
            ...cookie_data,
          };
          this.cookieService.set("platform-cookies", JSON.stringify(this.payload), expireDate);
          this.sharedService.setCookies(this.payload1).subscribe(() => undefined);
        }
      });
      this.showPopup = false;
      this.messageService.showSuccess(this.translate.instant("cookiePolicy.savedSuccessfully"))
      this.modalRef.close();
    }
  }

  acceptAllcookie() {
    this.payload = {
      functional: true,
      tracking: true,
      performance: true,
      personalization: true,
    };
    let expireDate = new Date;
    expireDate.setDate(expireDate.getDate() + 730);
    this.cookieService.set("platform-cookies", JSON.stringify(this.payload), expireDate);
    if (!this.authService.checkUser()) {
      this.showPopup = false;
    } else {
      this.sharedService.getCookies().subscribe((res: any) => {
        if (
          this.cookieService.get("platform-cookies") &&
          !res.isUserAcceptedCookiePolicy
        ) {
          let cookie_data = JSON.parse(
            this.cookieService.get("platform-cookies")
          );
          this.payload = {
            contentPageId: res.contentPage.id,
            version: res.contentPage.version,
            ...cookie_data,
          };
          this.cookieService.set("platform-cookies", JSON.stringify(this.payload), expireDate);
          this.sharedService.setCookies(this.payload).subscribe(() => undefined);
        }
      });
      this.messageService.showSuccess(this.translate.instant("cookiePolicy.savedSuccessfully"))
      this.showPopup = false;
    }
  }
}